import { useMediaQuery } from './useMediaQuery';

/**
 * Whether the screen is a phone, by the one width the phone rules break at.
 *
 * The chart drew its four tappable rows behind this query and kept the hook to
 * itself. The case's action bar folds behind it now too, since the request of
 * 24 September 2026, so it lives here for both.
 *
 * jsdom, the print pipeline and a server render have no `matchMedia`, and all
 * three read as the desktop, which is what every screen drew before there was a
 * phone layout at all. A test that wants the phone stubs `matchMedia`, as the
 * chart's phone test does.
 */
export const PHONE_QUERY = '(max-width: 619px)';

export function usePhoneLayout(): boolean {
  return useMediaQuery(PHONE_QUERY);
}
